import script from "./SearchFilterClose.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchFilterClose.vue?vue&type=script&setup=true&lang=js"

import "./SearchFilterClose.vue?vue&type=style&index=0&id=20b6cf51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b6cf51"]])

export default __exports__